export default __webpack_public_path__ + "assets/alert-6dfad89fc7adab74b9f42be521c64485.svg";